/* eslint-disable @typescript-eslint/no-use-before-define */
import React from "react";
import { Label } from "Application";

export const SessionExpiredView: React.FC = () => {
    return (
        <Label fontStyle={"h2"} color={"primary"}>
            Your session has expired!
        </Label>
    );
};
